import { render } from "./create-team.vue?vue&type=template&id=66c928aa&scoped=true&ts=true"
import script from "./create-team.vue?vue&type=script&lang=ts"
export * from "./create-team.vue?vue&type=script&lang=ts"

import "./create-team.vue?vue&type=style&index=0&id=66c928aa&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c928aa"]])

export default __exports__